(() => {
  if (window.tosSauronInlineBound) return;
  window.tosSauronInlineBound = true;
  let busy = false;
  const root = window.Shopify?.routes?.root || '/';
  const json = async (path, body) => {
    const response = await fetch(root + path, body ? {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body),
    } : { cache: 'no-store' });
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || 'cart-request');
    return data;
  };
  const isGift = (item) => Boolean(item.properties?._Sauron_Tshirt_Gift);
  document.addEventListener('change', (event) => {
    const panel = event.target.closest('[data-sauron-inline]');
    if (!panel || !event.target.matches('[data-ring-choice]')) return;
    panel.querySelector('.tos-sauron-gift__variant').hidden = event.target.value !== 'one';
    panel.querySelector('[data-selection-error]').hidden = true;
  });
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    const host = form.closest('product-form');
    if (!host || host.closest('quick-add-modal')) return;
    const panel = host.parentElement.querySelector('[data-sauron-inline]');
    if (!panel || String(host.dataset.productId) !== panel.dataset.shirtId) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const button = form.querySelector('[type="submit"]');
    if (busy || !button || button.disabled || button.getAttribute('aria-disabled') === 'true' || !form.reportValidity()) return;
    const selectionError = panel.querySelector('[data-selection-error]');
    const requestError = panel.querySelector('[data-request-error]');
    const cartLink = panel.querySelector('[data-cart-link]');
    const choice = panel.querySelector('[data-ring-choice]:checked')?.value;
    const select = panel.querySelector('[name="tos-sauron-ring-variant"]');
    const ringId = choice === 'sauron' ? Number(panel.dataset.sauronVariant) : choice === 'one' ? Number(select.value) : 0;
    selectionError.hidden = Boolean(ringId);
    requestError.hidden = true;
    cartLink.hidden = true;
    if (!ringId) {
      panel.scrollIntoView({ block: 'center', behavior: 'smooth' });
      (choice === 'one' ? select : panel.querySelector('[data-ring-choice]:not(:disabled)'))?.focus();
      return;
    }
    const data = new FormData(form);
    const shirtId = Number(data.get('id'));
    const quantity = Number(data.get('quantity') || 1);
    if (!Number.isSafeInteger(shirtId) || !Number.isSafeInteger(quantity) || quantity < 1) return;
    const shirt = { id: shirtId, quantity };
    const properties = {};
    for (const [key, value] of data) {
      const match = key.match(/^properties\[(.*)\]$/);
      if (match && value) properties[match[1]] = value;
    }
    if (Object.keys(properties).length) shirt.properties = properties;
    if (data.get('selling_plan')) shirt.selling_plan = Number(data.get('selling_plan'));
    const cartUI = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const sectionIds = cartUI?.getSectionsToRender?.().map((section) => section.id);
    const add = (items) => json('cart/add.js', { items, ...(sectionIds ? { sections: sectionIds, sections_url: location.pathname } : {}) });
    let latestCart;
    let latestResponse;
    let attempted = false;
    let uncertain = false;
    const showCart = () => {
      if (!uncertain && cartUI && latestResponse?.sections && latestCart) {
        const line = latestCart.items.find((item) => item.variant_id === shirtId);
        try {
          cartUI.classList.remove('is-empty');
          cartUI.renderContents({ ...latestResponse, key: line?.key });
          return;
        } catch (_) { /* Use the canonical cart if section rendering fails. */ }
      }
      location.assign(root + 'cart');
    };
    busy = true;
    button.setAttribute('aria-disabled', 'true');
    button.classList.add('loading');
    button.querySelector('.loading__spinner')?.classList.remove('hidden');
    cartUI?.setActiveElement?.(button);
    try {
      const before = await json('cart.js');
      const previous = before.items.find(isGift);
      // The existing automatic discount permits only one free ring per order.
      if (previous && (previous.variant_id !== ringId || previous.final_line_price !== 0)) throw new Error('existing-gift');
      const items = previous ? [shirt] : [{ id: ringId, quantity: 1, properties: { _Sauron_Tshirt_Gift: String(shirtId) } }, shirt];
      attempted = true;
      latestResponse = await add(items);
      latestCart = await json('cart.js');
      const gift = latestCart.items.find(isGift);
      if (!gift || gift.final_line_price !== 0) {
        if (!previous && gift) await json('cart/change.js', { id: gift.key, quantity: 0 });
        throw new Error('gift-not-free');
      }
      const dialog = panel.querySelector('[data-sauron-bag-dialog]');
      const bagId = Number(panel.dataset.bagVariant);
      if (!bagId || !dialog?.showModal || latestCart.items.some((item) => item.variant_id === bagId)) {
        showCart();
        return;
      }
      const toggle = dialog.querySelector('[name="tos-sauron-bag"]');
      const bagAdd = dialog.querySelector('[data-bag-add]');
      const decline = dialog.querySelector('[data-bag-decline]');
      const close = dialog.querySelector('[data-close]');
      const bagError = dialog.querySelector('[data-bag-error]');
      let bagBusy = false;
      let bagAttempted = false;
      toggle.checked = false;
      toggle.disabled = bagAdd.disabled = close.disabled = false;
      bagAdd.hidden = true;
      decline.hidden = false;
      bagError.hidden = true;
      toggle.onchange = () => { bagAdd.hidden = !toggle.checked; decline.hidden = toggle.checked; };
      close.onclick = decline.onclick = () => { if (!bagBusy) dialog.close(); };
      dialog.onclick = (e) => {
        e.stopPropagation();
        if (e.target === dialog && !bagBusy) dialog.close();
      };
      dialog.oncancel = (e) => { if (bagBusy) e.preventDefault(); };
      dialog.addEventListener('close', showCart, { once: true });
      bagAdd.onclick = async () => {
        if (bagBusy || bagAttempted) return;
        bagBusy = true;
        bagAdd.disabled = toggle.disabled = close.disabled = true;
        try {
          const cart = await json('cart.js');
          if (!cart.items.some((item) => item.variant_id === bagId)) {
            bagAttempted = true;
            latestResponse = await add([{ id: bagId, quantity: 1 }]);
          }
          latestCart = await json('cart.js');
          dialog.close();
        } catch (_) {
          uncertain = bagAttempted;
          bagError.hidden = false;
          decline.hidden = false;
          bagAdd.hidden = true;
        } finally {
          bagBusy = false;
          close.disabled = false;
        }
      };
      dialog.showModal();
    } catch (_) {
      requestError.textContent = panel.dataset.error;
      requestError.hidden = false;
      cartLink.hidden = false;
      // A failed response can still have changed the cart: do not retry blindly.
      if (attempted) button.disabled = true;
    } finally {
      busy = false;
      button.removeAttribute('aria-disabled');
      button.classList.remove('loading');
      button.querySelector('.loading__spinner')?.classList.add('hidden');
    }
  }, true);
})();
